module.exports = __webpack_public_path__ + "static/media/class_job_021.4fc7efc2.svg";